import {
  Component,
  computed,
  ElementRef,
  HostListener,
  inject,
  Input,
  OnChanges,
  OnInit,
  signal,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { VideoBackgroundComponent } from 'src/app/shared/ui-common/video-background/video-background.component';
import { SharedService } from 'src/app/shared/data/shared.service';
import { TranslatePipe } from 'src/app/shared/data/pipes/translate.pipe';
import { TranslationService } from 'src/app/shared/data/translation.service';
import { FeatureAnswersAnonymousComponent } from 'src/app/shared/feature-answers-anonymous/feature-answers-anonymous.component';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { updateDialogWidth } from 'src/app/shared/util/shared.util';

@Component({
  selector: 'app-auth-layout',
  imports: [CommonModule, VideoBackgroundComponent, TranslatePipe],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent implements OnChanges, OnInit {

  @Input() companyLogo = '';
  @ViewChild('imageContainer') imageContainer!: ElementRef;

  @HostListener('window:resize')
  onResize(): void {
    this.checkScreenWidth();
    this.dialogWidth = updateDialogWidth(this.answersAnonymousDialogRef);
  }

  dialog = inject(Dialog);
  isMobile = false;
  s3BaseUrl = environment.s3BaseUrl;
  email = signal<string | null>(null);
  isPinStep = computed(() => this.email() !== null);
  showHowdyVideo = false;
  language = 'English';
  videoFormat = '.mp4';
  answersAnonymousDialogRef!: DialogRef<unknown, FeatureAnswersAnonymousComponent>;
  dialogWidth!: number;

  get isHowdyLogo(): boolean {
    return this.companyLogo.includes('HRONWellbeing');
  }

  constructor(
    private sharedService: SharedService,
    private translationService: TranslationService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['companyLogo'] && changes['companyLogo'].currentValue) {
      this.companyLogo = changes['companyLogo'].currentValue;
    }
  }

  ngOnInit(): void {
    this.dialogWidth = updateDialogWidth(this.answersAnonymousDialogRef);
    this.videoFormat = this.sharedService.getVideoFormat();
    this.checkScreenWidth();
    const languageId = this.translationService.getLanguageId();
    this.language = languageId === '1041' ? 'Danish' : 'English';
  }

  getHowdyLogo(): void {
    this.companyLogo = this.sharedService.getHowdyLogoUrl();
  }

  checkScreenWidth(): void {
    this.isMobile = window.innerWidth < 1000;
  }

  scrollToWhy(): void {
    this.imageContainer.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  openAnswersAnonymousDialog(): void {
    this.answersAnonymousDialogRef = this.dialog.open(FeatureAnswersAnonymousComponent, {
      disableClose: true,
      width: `${this.dialogWidth}px`
    });
  }
}
